import { motion } from "framer-motion";

const CHAPTERS = [
    {
        num: "01",
        title: "Raíces en Alicante",
        text: "Conocemos el mercado local. Posicionamos tu marca en Alicante con contenido que conecta con la audiencia de la Costa Blanca — y desde aquí, con toda España.",
    },
    {
        num: "02",
        title: "Narrativa visual",
        text: "No solo grabamos: contamos historias. Desde el guion hasta el montaje final, cada fotograma tiene un propósito.",
    },
    {
        num: "03",
        title: "Ecosistema digital",
        text: "Unimos vídeo, fotografía, redes sociales y web para crear una máquina de conversión imparable para tu negocio.",
    },
];

export const Manifesto = () => {
    return (
        <section id="estudio" className="py-24 md:py-32 bg-navy text-cream overflow-hidden">
            <div className="max-w-7xl mx-auto px-6 md:px-12">
                <motion.p
                    initial={{ opacity: 0 }}
                    whileInView={{ opacity: 1 }}
                    viewport={{ once: true }}
                    transition={{ duration: 0.8 }}
                    className="font-mono text-xs uppercase tracking-[0.3em] text-coral mb-4"
                >
                    El estudio
                </motion.p>
                <motion.h2
                    initial={{ opacity: 0, y: 40 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true }}
                    transition={{ duration: 0.8, ease: [0.22, 1, 0.36, 1] }}
                    className="font-display text-4xl md:text-5xl font-bold tracking-tight mb-20 max-w-3xl"
                >
                    Hecho en Alicante, pensado para crecer
                </motion.h2>

                <div className="space-y-24">
                    {CHAPTERS.map((ch, i) => (
                        <motion.article
                            key={ch.num}
                            initial={{ opacity: 0, y: 60 }}
                            whileInView={{ opacity: 1, y: 0 }}
                            viewport={{ once: true, margin: "-60px" }}
                            transition={{ duration: 0.9, delay: 0.1, ease: [0.22, 1, 0.36, 1] }}
                            className={`relative flex flex-col md:flex-row md:items-end gap-6 md:gap-16 ${
                                i % 2 === 1 ? "md:flex-row-reverse" : ""
                            }`}
                            data-testid={`manifesto-chapter-${ch.num}`}
                        >
                            <span
                                aria-hidden="true"
                                className="font-display text-[9rem] md:text-[13rem] leading-none font-black text-cream/10 select-none"
                            >
                                {ch.num}
                            </span>
                            <div className="max-w-lg md:-mt-8">
                                <h3 className="font-display text-2xl md:text-3xl font-bold mb-4">
                                    {ch.title}
                                    <span className="text-coral">.</span>
                                </h3>
                                <p className="text-cream/70 text-base md:text-lg leading-relaxed">{ch.text}</p>
                            </div>
                        </motion.article>
                    ))}
                </div>

                <motion.figure
                    initial={{ opacity: 0, y: 60 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true, margin: "-60px" }}
                    transition={{ duration: 0.9, ease: [0.22, 1, 0.36, 1] }}
                    className="mt-24 md:ml-32 border border-cream/20"
                >
                    <img
                        src="https://images.unsplash.com/photo-1680537732160-01750bae5217?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1Mjh8MHwxfHNlYXJjaHwxfHxhbGljYW50ZSUyMHNwYWluJTIwc2t5bGluZXxlbnwwfHx8fDE3ODY3OTk3OTJ8MA&ixlib=rb-4.1.0&q=85"
                        alt="Skyline de Alicante, donde trabaja AS Studio"
                        className="w-full h-64 md:h-96 object-cover"
                        loading="lazy"
                    />
                    <figcaption className="font-mono text-xs uppercase tracking-[0.2em] text-cream/50 px-6 py-4">
                        Alicante — Costa Blanca
                    </figcaption>
                </motion.figure>
            </div>
        </section>
    );
};
